import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const GroupAddIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="groupAdd" ref={ref} {...props}>
      <path d="M6.75,12.32a.76.76,0,0,1-.75.75H4.75v1.25a.75.75,0,0,1-1.5,0V13.07H2a.75.75,0,0,1,0-1.5H3.25V10.32a.75.75,0,0,1,1.5,0v1.25H6A.75.75,0,0,1,6.75,12.32ZM15.89,9a3.66,3.66,0,1,0-3.66,3.66A3.66,3.66,0,0,0,15.89,9Zm-1.5,0a2.16,2.16,0,1,1-2.16-2.16A2.16,2.16,0,0,1,14.39,9ZM18.1,19a4.53,4.53,0,0,0-4.52-4.52H10.82A4.53,4.53,0,0,0,6.29,19a.75.75,0,0,0,1.5,0,3,3,0,0,1,3-3h2.76a3,3,0,0,1,3,3,.75.75,0,1,0,1.5,0Zm1.14-7.1a3.66,3.66,0,0,0-.87-6.33A.75.75,0,1,0,17.83,7,2.14,2.14,0,0,1,19.2,9a2.16,2.16,0,0,1-.86,1.73.75.75,0,0,0-.15,1.05.76.76,0,0,0,.6.29A.68.68,0,0,0,19.24,11.89ZM22.71,19a4.55,4.55,0,0,0-2.57-4.08.75.75,0,1,0-.65,1.35A3.06,3.06,0,0,1,21.21,19a.75.75,0,1,0,1.5,0Z" />
    </Icon>
  ),
) as IconWithRender;

GroupAddIcon.displayName = 'GroupAddIcon';
GroupAddIcon.renderIcon = (props) => <GroupAddIcon {...props} />;
export default GroupAddIcon;
